import styled from 'styled-components';

import Container from 'ggApp/shared/common/Container';

import LoggedInControls from './LoggedInControls';
import LoggedOutControls from './LoggedOutControls';
import PageLinks from './PageLinks';
import HomeLink from './HomeLink';

const Wrap = styled(Container)`
    ${({ theme }) => theme.maxWidth};
    width: 100%;
    background: ${({ theme }) => theme.colors.Background};
    padding: 12px 80px 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    z-index: 1;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        padding: 16px 16px 0;
    `};
`;

const Home = styled(HomeLink)`
    margin-right: 40px;
`;

const Links = styled(PageLinks)`
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        margin-left: auto;
    `};
`;

const LoggedIn = styled(LoggedInControls)`
    margin-left: auto;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        display: none;
    `};
`;

const LoggedOut = styled(LoggedOutControls)`
    margin-left: auto;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.tabletMax.css`
        display: none;
    `};
`;

export {
    Wrap,
    Home,
    Links,
    LoggedIn,
    LoggedOut
};
